<template>
  <div class="MenuSide">
    <div class="menuSideTopBox"></div>
    <el-menu
      :default-active="$route.path"
      :router="true"
      :unique-opened="true"
      class="menu-side"
      :collapse="isCollapse"
      background-color="#fff"
      active-text-color="#333333"
      text-color="#000"
    >
      <article v-for="item in menus" :key="item.data.code">
        <div class="menu-side-title">
          <p>{{ $t("pages.wording." + item.data.code) }}</p>
        </div>
        <div v-for="child in item.children" :key="child.data.code">
          <el-menu-item :index="getRouterPath(child.data.code)" style="text-align: left">
            <i :class="child.data.icon"></i>
            <span slot="title">{{ $t("pages.wording." + child.data.code) }}</span>
          </el-menu-item>
        </div>
      </article>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: "MenuSide",
  data() {
    return {
      isCollapse: false,
      menus: {},
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getUserRoles"]),
    setMenuBar() {
      this.menus = this.getUserProfile().menu
    },
    getRouterPath(code) {
      return this.$router.resolve({ name: code }).href.replace("#", "")
    },
  },
  computed: {
    auth: function () {
      return this.getUserRoles()
    },
    userProfile() {
      return this.getUserProfile()
    },
  },
  mounted() {
    this.setMenuBar()
  },
  watch: {
    userProfile() {
      this.setMenuBar()
    },
  },
}
</script>

<style>
.menu-side {
  background-color: #fff;
  border-right: solid 0px #e6e6e6;
  position: absolute;
  top: 50px;
  bottom: 0px;
  text-align: left;
  overflow-y: auto;
}
.menu-side:not(.el-menu--collapse) {
  width: 299px;
  /*border-right: solid 0px #e6e6e6;*/
}
.menu-side-title {
  color: #00a0e9;
  font-size: 16px;
  font-weight: bold;
  padding: 30px 0 0 15px;
}
.menuSideTopBox {
  height: 50px;
  width: 100%;
  background-color: #00a0e9;
  box-shadow: 0 5px 8px -4px #909399e0;
}
.el-menu-item {
  padding-left: 30px;
}
.el-menu-item:hover {
  outline: 0 !important;
  background-color: #e8e8e8 !important;
}
.el-menu-item.is-active {
  background-color: #e6f1fc !important;
  color: #00a0e9 !important;
  font-weight: 800;
}
.el-submenu__title:focus,
.el-submenu__title:hover {
  outline: 0 !important;
  background-color: #f5f5f5 !important;
}
.menu-border-bottom {
  background-color: #ddd;
  height: 1px;
}
.el-menu-item [class^="el-icon-"] {
  font-size: 25px !important;
  margin-right: 25px !important;
}
.el-submenu [class^="el-icon-"] {
  margin-right: 25px;
}
.el-menu-item i {
  color: #00a0e9 !important;
}
.el-aside {
  overflow: hidden;
}
.MenuSide li {
  font-size: 1.2rem;
}
.menu-side-title {
  font-size: 1.5rem;
}
</style>
